import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "react-loading-skeleton/dist/skeleton.css";
import 'react-credit-cards-2/dist/es/styles-compiled.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
    </StrictMode>
);

